module.exports = __webpack_public_path__ + "img/0Q3A7086_L_Foamcore_MockedUp.f21199f8.jpg";